export const metricDataVariables = /* GraphQL */ `
  $search_id: String,
  $search_context: String,
  $user_id: String,
  $new_buyer: Boolean,
  $browser_id: String
`
